const route = {
	path: 'accounting-rules/:id/edit',
	name: 'accounting-rules-edit',
	meta: {
		title: 'Editar Regla Contable',
	},
	component: () => import('@/pages/accounting-rules/page-accounting-rule-new'),
	props: true,
};

export default route;



// WEBPACK FOOTER //
// ./src/router/accounting-rules-edit.js